import * as types from '../../actions/action-types';
import api from '../../../api';
import AppConfig from '../../../config';
import moment from 'moment';
import _ from 'lodash';


export function setAuthState(sessionId, profile, updateLocalStorageSessionState = false) {

  // validate the logged in status
  let isLoggedIn = false;
  if (sessionId && profile) {
    isLoggedIn = true;
  } else {
    sessionId = null;
    profile = null;
  }

  if (updateLocalStorageSessionState) {
    let expiresSecs = _.get(AppConfig, 'auth.sessionExpiresSecs', null);
    if (!_.isFinite(expiresSecs) || expiresSecs <= 0) {
      expiresSecs = 30 * 60;
    }

    let createdAt = moment();
    let expiresAt = moment(createdAt).add(expiresSecs, 'seconds');
    let sessionStateJson = JSON.stringify({
      createdAt,
      expiresAt,
      token: sessionId
    });
    localStorage.setItem('authToken', sessionStateJson);
  }

  api.config.authToken = sessionId;

  return { type: types.SET_AUTH_STATE, payload: { sessionId, profile, isLoggedIn } };
}

export function clearAuthState() {

  // clear all session state
  localStorage.setItem('authToken', null);
  api.config.authToken = null;

  return { type: types.SET_AUTH_STATE, payload: { sessionId: null, profile: null, isLoggedIn: null } };
}

export function getAuthSessionState() {
  let retval = null;
  try {
    let now = moment();
    let sessionStateJson = localStorage.getItem('authToken');
    let sessionState = !_.isEmpty(sessionStateJson)? JSON.parse(sessionStateJson): null;
    if (sessionState && sessionState.expiresAt) {
      let expiresAt = moment(sessionState.expiresAt);
      if (expiresAt && expiresAt.isValid() && expiresAt.isAfter(now)) {
        retval = sessionState;
      }
    }
  } catch (ex) {}
  return retval;
}

export function getAuthSessionStateToken() {
  return _.get(getAuthSessionState(), 'token', null);
}
